import React, { useState, useEffect } from "react";
import { serverFetch } from "@extensions";
import { useCompany, useUser } from "@redux";
import { Image, Spin, message } from "antd";
import "./catalog-sale-users.css";

const CatalogSaleRooms = ({ productId, selectedDate, onSelect }) => {
  const company = useCompany();
  const user = useUser();
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRoomId, setSelectedRoomId] = useState(null);

  useEffect(() => {
    if (productId && selectedDate && company) {
      fetchRooms();
    } else {
      setRooms([]);
      setSelectedRoomId(null);
      if (onSelect) {
        onSelect(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId, selectedDate, company]);

  const fetchRooms = async () => {
    if (!company || !productId || !selectedDate) return;

    setLoading(true);
    setSelectedRoomId(null);
    if (onSelect) {
      onSelect(null);
    }

    try {
      const queryParams = {
        productId: productId,
        date: selectedDate.format("YYYY-MM-DD"),
      };
      const data = await serverFetch("Online/ProductRooms", { method: "GET", queryParams: queryParams }, user);
      setRooms(data || []);
      if (data && data.length > 0) {
        setSelectedRoomId(data[0].id);
        if (onSelect) {
          onSelect(data[0]);
        }
      }
    } catch (error) {
      console.error("Ошибка получения залов:", error);
      message.error(error?.UserMessage || "Не удалось загрузить список залов");
      setRooms([]);
    } finally {
      setLoading(false);
    }
  };

  const handleRoomSelect = (room) => {
    setSelectedRoomId(room.id);
    if (onSelect) {
      onSelect(room);
    }
  };

  if (loading) {
    return (
      <div className="catalog-sale-users-loading">
        <Spin size="small" />
      </div>
    );
  }

  if (!rooms || rooms.length === 0) {
    return null;
  }

  return (
    <div className="catalog-sale-users">
      <div className="catalog-sale-users-title">Выберите зал</div>
      <div className="catalog-sale-users-list">
        {rooms.map((room) => (
          <div
            key={room.id}
            className={`catalog-sale-users-card ${selectedRoomId === room.id ? "selected" : ""}`}
            onClick={() => handleRoomSelect(room)}
          >
            {room.imageId && (
              <div className="catalog-sale-users-photo">
                <Image
                  src={`${process.env.REACT_APP_API_BASE_URL}/api/image/${room.imageId}`}
                  alt={room.name}
                  preview={false}
                  className="catalog-sale-users-image"
                />
              </div>
            )}
            <div className="catalog-sale-users-info">
              <div className="catalog-sale-users-name">{room.name}</div>
              {room.description && <div className="catalog-sale-users-position">{room.description}</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CatalogSaleRooms;
